import React, { useState } from "react";
import Helmet from "react-helmet";
import classnames from "classnames";
import { IntlContextConsumer, changeLocale } from "gatsby-plugin-intl";
import ExpandArrow from "../../assets/ExpandArrow";
import cssClass from "./LanguagePicker.module.scss";

const LanguagePicker = ({ invert, isMobileNav }) => {
  const [isToggled, setIsToggled] = useState(false);

  const renderLanguageChoice = (code, isCurrentLocale) => {
    const handleClick = (code) => {
      changeLocale(code);
      setIsToggled(false);
    };

    const mapCodeToName = {
      en: "English",
      de: "Deutsch",
      es: "Español",
    };

    return (
      <li key={code}>
        <button
          className={classnames(cssClass.item, {
            [cssClass.isCurrentLocale]: isCurrentLocale,
          })}
          onFocus={() => setIsToggled(true)}
          onClick={() => handleClick(code)}
        >
          {mapCodeToName[code] || code}
        </button>
      </li>
    );
  };

  return (
    <IntlContextConsumer>
      {({ languages, language: currentLocale }) => (
        <div
          className={classnames(cssClass.languagePicker, {
            [cssClass.open]: isToggled,
            [cssClass.invert]: invert,
          })}
          onMouseEnter={() => setIsToggled(true)}
          onMouseLeave={() => setIsToggled(false)}
          onFocus={() => setIsToggled(true)}
          onBlur={() => setIsToggled(false)}
        >
          <Helmet>
            <html lang={currentLocale} />
          </Helmet>
          <button
            className={cssClass.pickerButton}
            id={isMobileNav ? "languagePickerMobile" : "languageDropdown"}
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded={isToggled}
            aria-hidden={isMobileNav}
          >
            {currentLocale}
            <ExpandArrow
              isFilled
              colour={invert ? "white" : "var(--color-cool-dark)"}
            />
          </button>
          <ul
            className={classnames(cssClass.dropdown, {
              [cssClass.hidden]: !isToggled,
            })}
            aria-hidden={!isToggled}
            aria-labelledby="languageDropdown"
          >
            {languages.map((code) =>
              renderLanguageChoice(code, code === currentLocale)
            )}
          </ul>
        </div>
      )}
    </IntlContextConsumer>
  );
};

export default LanguagePicker;
